export default {

  handleFormValidation() {

    let oForm = $('#form-crawler-credential');

    let aRules = {
      key: {
        required: true
      },
      username: {
        required: true,
      },
      password: {
        required: true,
      },
    };

    let aMessages = {
      nombre: {
        required: 'El campo Key es obligatorio.'
      },
      username: {
        required: 'El campo Username es obligatorio.',
      },
      password: {
        required: 'El campo Password es obligatorio.',
      },
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },


  init() {
    this.handleFormValidation();
  },

  initIndex() {
    FormHelper.handleSearch();
  },

  /**
   * Elimina un registro a traves de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} nombre Nombre del registro a eliminar
   */
  eliminar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas eliminar la Credencial <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
    FormHelper.confirm(form, mensaje);
  }
};
